import Button from 'atoms/button';
import PropTypes from 'prop-types';
import React from 'react';


export const ADVERTISERS = {
  Airbnb: '-airbnb-decoration',
};

export const SUGGESTION_BOX_ACTIONS = {
  CLOSE: 'close',
  OPEN: 'open',
};

export default function SuggestionBox({
  className, handleOnClick, adLogo, text, advertiser, t,
}) {
  return (
    <div className={ `suggestion-box ${className} ${advertiser}` } onClick={ handleOnClick.bind(this, SUGGESTION_BOX_ACTIONS.OPEN) }>
      <div className="suggestion-box__close hundredicons-arrow-up-filled" />
      <div className={ `suggestion-box__inside ${advertiser}` }>
        <div className="suggestion-box__inside__close hundredicons-cross" onClick={ handleOnClick.bind(this, SUGGESTION_BOX_ACTIONS.CLOSE) } />
        <img alt="" className="suggestion-box__inside__logo" src={ adLogo } />
        <div className="suggestion-box__inside__container">
          <div className="suggestion-box__inside__container__text">
            { t(text) }
          </div>
          <Button className="suggestion-box__inside__container__button">
            { t('View offer') }
          </Button>
        </div>
      </div>
    </div>
  );
}

SuggestionBox.defaultProps = {
  className: '',
};

SuggestionBox.propTypes = {
  adLogo: PropTypes.string.isRequired,
  advertiser: PropTypes.oneOf(Object.values(ADVERTISERS)).isRequired,
  className: PropTypes.string,
  handleOnClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};
